<p-toast position="top-right" [breakpoints]="toastBreakpoints"></p-toast>
<router-outlet></router-outlet>
